module.exports = __webpack_public_path__ + "static/img/amexLogo.4723e95.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/amexLogo.jpg
// module id = Gus7
// module chunks = 1